import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { closeModal, createDevice } from '../actions/entry';
import AddDeviceToDiagramModal from '../components/DeviceModal/AddDeviceToDiagram';

const mapStateToProps = ({ deviceCreateForm: { data: defaultData, isSubmitting } }) => ({
  defaultData,
  isSubmitting,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onCreate: createDevice,
      onClose: closeModal,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddDeviceToDiagramModal);
